import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { useIntl } from "react-intl"
import { getTextTokens } from "../contentfulClient"
import { getContentfulLocale } from "../utils/contentfulLocaleUtils"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import ResponseError from "#/types/responseError"
import { EntryWithoutUnresolvableLinks } from "#/utils/ContentTypes"
import { TypeTextTokenSkeleton } from "#/types/contentful"

const TEXT_TOKENS_QUERY_KEY = "textTokens"

export type TextTokenEntry = EntryWithoutUnresolvableLinks<TypeTextTokenSkeleton>

export function useGetTextTokens(): UseQueryResult<TextTokenEntry[], ResponseError> {
  const intl = useIntl()
  const contentfulLocale = getContentfulLocale(intl.locale)

  return useQuery<TextTokenEntry[], ResponseError>(
    [TEXT_TOKENS_QUERY_KEY, contentfulLocale],
    async () => {
      const items = await getTextTokens(contentfulLocale)
      return items as TextTokenEntry[]
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: buildCarrotApiRetryPolicy(3)
    }
  )
}
